<template>
  <KTTable
    title="Flotas"
    subtitle="Lista de Flotas"
    :fields="fields"
    :endpoint="endpoint"
    :delete="DELETE_FLOTA"
    @edit="editItem($event)"
  ></KTTable>
</template>

<script>
import KTTable from "@/view/content/Table.vue";
import { DELETE_FLOTA } from "@/core/services/store/flotas.module";

export default {
  name: "dashboard",
  components: { KTTable },
  data() {
    return {
      DELETE_FLOTA,
      endpoint: "dic_flotas",
      fields: [
        {
          key: "id_flota",
          label: "Id Flota",
          sortable: true
        },
        {
          key: "descripcion",
          label: "Literal FLota",
          sortable: true
        },
        {
          key: "actions",
          label: ""
        }
      ]
    };
  },
  methods: {
    editItem(item) {
      this.$router.push(`${this.$route.path}/${item.id_flota}`);
    }
  }
};
</script>
